import { TYPE } from "../actions/types";

const intialState ={
  getTransactionRes:{}
}

export default function (state = intialState, action) {
  switch (action.type) {
    case TYPE.GET_USER_TRANSACTION:
      state.getTransactionRes = action.payload
      return {...state,response: action.payload}
    case TYPE.GET_BOOKING_HISTORY:
      return { ...state, response: action.payload };
    case TYPE.GET_PENDING_BOOKINGS:
      return { ...state, response: action.payload };
    case TYPE.UPDATE_CHECKIN_STATUS:
      return { ...state, response: action.payload };
    case TYPE.DENY_BOOKING:
      return { ...state, response: action.payload };
    case TYPE.GET_PACKAGE_BOOKING_HISTORY:
      return { ...state, response: action.payload };
    case TYPE.BOOKING_VOUCHER:
      return { ...state, response: action.payload };
    case "clear_user_transaction_res":
      state.getTransactionRes = {}
      return {...state,response: action.payload}
    default:
      return state;
  }
}
